import React, { Component } from 'react'
import { graphql, compose } from 'react-apollo'
import { translate } from 'react-i18next'
import { withRouter } from 'react-router-dom'
import classNames from 'classnames'
import moment from 'moment'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Marker } from 'react-google-maps'
import Activities from './Activities'
import Activity from './Activity'
import AddExternalDayModal from './AddExternalDayModal'
import AddEventModal from './AddEventModal'
import EditEventModal from './EditEventModal'
import EditTripModal from './EditTripModal'
import AddPOIFormModal from '../POIForm/AddPOIFormModal'
import EditPOIFormModal from '../POIForm/EditPOIFormModal'
import AddNotesModal from '../Notes/AddNotesModal'
import ViewContentNotesModal from '../Notes/ViewContentNotesModal'
import Sidebar from './Sidebar'
import Map from './Map'
import InputWithOutsideClick from './InputWithOutsideClick'
import { DragDropContext } from 'react-beautiful-dnd'
import { Loader } from '../UI'
import { Droppable } from 'react-beautiful-dnd'
import { NotificationManager } from 'react-notifications'
import { enumerateDaysBetweenDates } from './../../libs/utils'
import queries from './../../graphql/TripPlanner'
import GET_CONTENT_NOTE from './../../graphql/Note/GetContentNote.graphql'
import EditNoteModal from '../Notes/EditNoteModal'
const POI = 'POI'
const NOTES = 'NOTES'
const LIST_VIEW = 'LIST_VIEW'
const MAP_VIEW = 'MAP_VIEW'
const google = window.google
class TripPlanner extends Component {
  static propTypes = {
    t: PropTypes.func,
    contentPOI: PropTypes.object,
    customizedPlan: PropTypes.object,
    createAllItineraryDays: PropTypes.func,
    createItineraryDay: PropTypes.func,
    updateCustomizedPlanEndDate: PropTypes.func,
    updateEventTitle: PropTypes.func,
    updateContentEventStartDate: PropTypes.func,
    updateItineraryDayTitle: PropTypes.func,
    updateItineraryDayFavorite: PropTypes.func,
    updateItineraryDayOrder: PropTypes.func,
    linkItineraryDayAndTripDetails: PropTypes.func,
    linkItineraryDayAndContentEvent: PropTypes.func,
    unLinkItineraryDayAndTripDetails: PropTypes.func,
    linkIterneraryDayAndNote: PropTypes.func,
    unLinkIterneraryDayAndNote: PropTypes.func
  }
  constructor(props) {
    super(props)
    this.state = {
      activeLibraryTab: POI,
      activePlanView: LIST_VIEW,
      addEventModal: false,
      addExternalDayModal: false,
      editEventModal: false,
      editTrip: false,
      eventForEditing: null,
      searchKey: '',
      selectedDayIndex: 0,
      libraryContentPOIs: [],
      libraryEvents: [],
      libraryNotes: [],
      days: [],
      showLoader: false,
      isItineraryDaysCreating: false,
      newDayTitle: '',
      isDayTitleEditing: false,
      POIFormModal: false,
      EditPOIFormModal: false,
      addNotesModal: false,
      editNotesModal: false,
      viewContentNotesModal: false,
      isToggleOn: false,
      firstCheck :0
    }
  }

  componentDidMount() {
    

  }

  componentWillReceiveProps(next) {
    const { t } = this.props

    console.log('next value will receive prop', next)

    if (next.customizedPlan.customizedplan) {
      this.setState({ trip: next.customizedPlan.customizedplan[0] })
    }
    if (next.contentPOI.contentpoi) {
      console.log(next.contentPOI.contentpoi);
      this.setState({ libraryContentPOIs: next.contentPOI.contentpoi })
    }
    //const customizedPlan = _.get(next, 'customizedPlan.CustomizedPlan')
    const customizedPlan = this.state.trip

    console.log(this.state.trip)

    if (customizedPlan) {
      let days
      if (customizedPlan.startDate && customizedPlan.endDate) {
        days = enumerateDaysBetweenDates(customizedPlan.startDate, customizedPlan.endDate)
      } else {
        days = new Array(customizedPlan.numdays).fill(null)
      }
      const tripDetails = customizedPlan.tripDetails

      console.log('here is mycustomized details', tripDetails.TripItinerarydays[0].itineraryday.isFavorite);

      if(tripDetails.TripItinerarydays.length && this.state.firstCheck == 0) {
        this.setState({
          isToggleOn:tripDetails.TripItinerarydays[0].itineraryday.isFavorite,
          firstCheck: 1
        })
      }

      if ((!Array.isArray(tripDetails.TripItinerarydays) || !tripDetails.TripItinerarydays.length) && !this.state.isItineraryDaysCreating) {
        this.setState(
          {
            isItineraryDaysCreating: true,
            showLoader: true
          },
          async () => {
            try {
              let response = await this.props.createAllItineraryDays({
                variables: {
                  id: customizedPlan.tripDetails.id,
                  TripItinerarydays: days.map((day, i) => {
                    const dayTitle = t('create_trip:day_prefix') + (i + 1)
                    const newDate = {
                      index: i,
                      title: dayTitle
                    }
                    if (day) {
                      newDate.dayOfTrip = day.itineraryday.startOf('day').toISOString()
                    }
                    return newDate
                  })
                }
              })
              let updatedCustomizedPlan = _.cloneDeep(customizedPlan)
              updatedCustomizedPlan.tripDetails.TripItinerarydays = response.data.updateTripDetails.itineraryDays
              this.setState({trip: updatedCustomizedPlan})
              this.filterNotes(next)
              this.setState({
                showLoader: false
              })
            } catch (err) {
              NotificationManager.error(err.message, 'Error', 5000)
            }
          }
        )
      } else {
        this.filterNotes(next)
      }
    }
  }
  async onAddDay() {

    const { t } = this.props
    const {createItineraryDay, updateCustomizedPlanEndDate, linkItineraryDayAndTripDetails } = this.props
    const customizedPlan = this.state.trip
    const days = this.getDays()
    let endDate
    if (days[days.length - 1].dayOfTrip) {
      endDate = moment(days[days.length - 1].dayOfTrip)
        .add(1, 'day')
        .toISOString()
      this.setState({
        showLoader: true
      })
      try {
        await updateCustomizedPlanEndDate({
          variables: {
            id: this.state.trip.id,
            endDate
          }
        })
      } catch (err) {
        NotificationManager.error(err.message, 'Error', 5000)
      }
    }
    let data
    try {
      const dayTitle = t('create_trip:day_prefix') + (days.length + 1)
      const variables = {
        index: days.length,
        title: dayTitle
      }
      if (endDate) {
        variables.dayOfTrip = endDate
      }
      const res = await createItineraryDay({ variables })
      data = res.data
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }
    try {
      await linkItineraryDayAndTripDetails({
        variables: {
          itineraryDayId: data.createItineraryDay.id,
          tripDetailsId: this.state.trip.tripDetails.id
        }
      })
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }
    try {
      setTimeout(async () => {
        await customizedPlan.refetch()
      }, 0)
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }
    this.setState({
      showLoader: false
    })
  }
  async saveNewDayTitle() {
    const currentDay = this.getCurrentDay()
    if (this.state.newDayTitle === currentDay.title) return
    this.setState({
      showLoader: true
    })
    try {
      await this.props.updateItineraryDayTitle({
        variables: {
          id: currentDay.id,
          title: this.state.newDayTitle
        }
      })
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }
    try {
      setTimeout(async () => {
        await this.props.customizedPlan.refetch()
      }, 0)
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }
    this.setState({
      showLoader: false
    })
  }
  async onEventRemoveFromPlan(eventId) {
    const { unLinkItineraryDayAndTripDetails } = this.props
    const currentDay = this.getCurrentDay()
    try {
      await unLinkItineraryDayAndTripDetails({
        variables: {
          itineraryDayId: currentDay.id,
          contentEventId: eventId
        }
      })
      NotificationManager.success('Event removed from plan', 'Success', 5000)
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }
    try {
      setTimeout(async () => {
        await Promise.all([this.props.customizedPlan.refetch()])
      }, 0)
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }
  }
  async onNoteRemoveFromPlan(noteId) {
    const { unLinkItineraryDayAndNote } = this.props
    const currentDay = this.getCurrentDay()
    try {
      await unLinkItineraryDayAndNote({
        variables: {
          itineraryDayId: currentDay.id,
          noteId: noteId
        }
      })
      NotificationManager.success('Note removed from plan', 'Success', 5000)
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }
    try {
      setTimeout(async () => {
        await Promise.all([this.props.customizedPlan.refetch(), this.props.contentNote.refetch()])
      }, 0)
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }
  }
  async onExternalDayCloseModal(isSaved, event, selectedDayIndex) {
    try {
      setTimeout(async () => {
        await Promise.all([
          await this.props.customizedPlan.refetch()
        ])
      }, 0)
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }
  }
  async onEventCloseModal(isSaved, event, selectedDayIndex) {
    try {
      setTimeout(async () => {
        await Promise.all([
          await this.props.contentPOI.refetch(),
          await this.props.contentNote.refetch(),
          await this.props.customizedPlan.refetch()
        ])
      }, 0)
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }
    if (isSaved) {
      this.setState({ selectedDayIndex }, async () => {
        try {
          await this.onEventClick({
            id: event.id
          })
        } catch (err) {
          NotificationManager.error(err.message, 'Error', 5000)
        }
      })
    }
  }
  async onDateEdited(event, day, newDate) {
    try {
      if (day.dayOfTrip !== newDate.toISOString()) {
        // Date changed
        console.log('date change ' + day.dayOfTrip + ' vs ' + newDate.toISOString())
        // Update the event time - same time different date
        let eventStartTime = moment(event.startDate)
        const startHour = eventStartTime.hour()
        const startMinute = eventStartTime.minute()
        eventStartTime = new moment(newDate).hour(startHour).minute(startMinute)
        this.onTimeEdited(event, eventStartTime, true)
        // Remove event from current day
        await this.props.unlinkItineraryDayAndContentEvent({
          variables: {
            itineraryDayId: day.id,
            contentEventId: event.id
          }
        })
        // Add event to the new day
        let newDayItem = this.getDayByDate(newDate)
        await this.props.linkItineraryDayAndContentEvent({
          variables: {
            itineraryDayId: newDayItem.id,
            contentEventId: event.id
          }
        })
      }
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }
    try {
      setTimeout(async () => {
        await this.props.customizedPlan.refetch()
      }, 0)
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }
  }
  async onTimeEdited(event, time, dateChange) {
    try {
      let newStart = time.toISOString()
      if (event.type === 'Activity' || event.type === 'Info') {
        let start = moment(event.startDate)
        let end = moment(event.endDate)
        let duration = end.diff(start, 'minutes')
        let newEnd = time.add(duration, 'minutes').toISOString()
        await this.props.updateContentEventDates({
          variables: {
            id: event.id,
            startDate: newStart,
            endDate: newEnd
          }
        })
      }
      else {
        await this.props.updateContentEventStartDate({
          variables: {
            id: event.id,
            startDate: newStart
          }
        })
      }
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }
    if (!dateChange) {
      try {
        setTimeout(async () => {
          await this.props.customizedPlan.refetch()
        }, 0)
      } catch (err) {
        NotificationManager.error(err.message, 'Error', 5000)
      }
    }
  }
  onEventClick(event) {
    this.setState(
      {
        showLoader: true
      },
      async () => {
        const currentDay = this.getCurrentDay()
        try {
          await this.props.linkItineraryDayAndContentEvent({
            variables: {
              itineraryDayId: currentDay.id,
              contentEventId: event.id
            }
          })
        } catch (err) {
          NotificationManager.error(err.message, 'Error', 5000)
        }
        try {
          setTimeout(async () => {
            await this.props.customizedPlan.refetch()
          }, 0)
        } catch (err) {
          NotificationManager.error(err.message, 'Error', 5000)
        }
        this.setState({
          showLoader: false
        })
      }
    )
  }
  onMapViewSelect() {
    this.setState(
      {
        activePlanView: MAP_VIEW
      },
      () => {
        if (this.map && _.isFunction(this.map.fitBounds)) {
          const bounds = new google.maps.LatLngBounds()
          const currentDay = this.getCurrentDay()
          currentDay.contentEvents.filter(event => !!_.get(event, 'contentPOIs[0].place')).forEach(event => {
            const { lat, lng } = event.contentPOIs[0].place
            bounds.extend(new google.maps.LatLng(lat, lng))
          })
          this.map.fitBounds(bounds)
        }
      }
    )
  }

  async onDeleteAllEvents() {
    // console.log('inside delete All');
    const { unLinkItineraryDayAndTripDetails } = this.props
    const currentDay = this.getCurrentDay()
    const currentDayId = currentDay.id;
    // console.log(currentDay);

    const deleteResponse = currentDay.contentEvents
      .map(async (event, i) =>{
        try {
          await unLinkItineraryDayAndTripDetails({
            variables: {
              itineraryDayId: currentDayId,
              contentEventId: event.id
            }
          })
          // NotificationManager.success('Event removed from plan', 'Success', 5000)
          console.log('inside try block', event.id);
        } catch (err) {
          NotificationManager.error(err.message, 'Error', 5000)
        }
      })
    
      
      if(await deleteResponse){
        console.log(deleteResponse);
        NotificationManager.success('All Events removed from plan', 'Success', 5000)
      } 

    try {
      setTimeout(async () => {
        await Promise.all([this.props.customizedPlan.refetch()])
      }, 0)
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }

  }

  async onStarToggle() {

    console.log('isToggleOn value ', this.state.isToggleOn)

    await this.setState(state => ({
      isToggleOn: !state.isToggleOn
    }));

    console.log('isToggleOn value after ', this.state.isToggleOn)


    const currentDay = this.getCurrentDay()
    if (this.state.isToggleOn === currentDay.isFavorite) return
      this.setState({
        showLoader: true
      })
    try {
      await this.props.updateItineraryDayFavorite({
        variables: {
          id: currentDay.id,
          isFavorite: this.state.isToggleOn
        }
      })
      if(this.state.isToggleOn) {
        NotificationManager.success('ItineraryDay Added To Favorite List', 'Success', 5000)
      }else {
        NotificationManager.success('Remove from favorites.', 'Success', 5000)
      }
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }

    try {
      setTimeout(async () => {
        await this.props.customizedPlan.refetch()
      }, 0)
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }

    this.setState({
      showLoader: false
    })
  }

  onDayTitleEditClick() {
    const currentDay = this.getCurrentDay()
    this.setState(
      {
        isDayTitleEditing: true,
        newDayTitle: currentDay.title
      },
      () => {
        this.input.focus()
      }
    )
  }
  filterNotes(props) {
    const allNotes = _.get(props, 'contentNote.note', [])
    this.setState({ libraryNotes: allNotes })
  }
  closeModal(cb) {
    this.setState(
      {
        addEventModal: false,
        addExternalDayModal: false,
        editEventModal: false,
        editTrip: false,
        POIFormModal: false,
        eventForEditing: null,
        EditPOIFormModal: false,
        POIData: null,
        addNotesModal: false,
        editNotesModal: false,
        viewContentNotesModal: false
      },
      () => {
        if (_.isFunction(cb)) {
          cb()
        }
      }
    )
  }
  onLibraryTabChange(tab) {
    this.setState({
      activeLibraryTab: tab,
      searchKey: ''
    })
  }
  onKeyUp(event) {
    event.persist()
    if (event.key === 'Enter') {
      this.setState(
        {
          isDayTitleEditing: false
        },
        () => {
          this.saveNewDayTitle()
        }
      )
    }
  }
  onClickOutside() {
    this.setState(
      {
        isDayTitleEditing: false
      },
      () => {
        this.saveNewDayTitle()
      }
    )
  }
  onCustomizedPlanCloseModal() {
    this.setState(
      {
        showLoader: true
      },
      async () => {
        try {
          await this.props.customizedPlan.refetch()
        } catch (err) {
          NotificationManager.error(err.message, 'Error', 5000)
        }
        this.setState({
          showLoader: false
        })
      }
    )
  }
  async moveDay(firstDay, secondDay) {
    const getDayPromise = (day, swapDay) => {
      return this.props.updateItineraryDayOrder({
        variables: {
          id: day.id,
          dayOfTrip: swapDay.dayOfTrip,
          index: swapDay.index
        }
      })
    }
    const getEventsWithModifiedDatesPromise = (day, swapDay) => {
      return day.contentEvents.map(event => {
        // Check the diff of days between the start and end date of the event
        let diffDays = moment(event.endDate).startOf('day').diff(moment(event.startDate).startOf('day'), 'days')
        // Keep existing times before setting the date
        const startHour = moment(event.startDate).hour()
        const startMinute = moment(event.startDate).minute()
        let startDate = moment(swapDay.dayOfTrip).startOf('day')
        const endHour = moment(event.endDate).hour()
        const endMinute = moment(event.endDate).minute()
        const endDate = startDate.add(diffDays, 'days').hour(endHour).minute(endMinute).toISOString()
        startDate = startDate.hour(startHour).minute(startMinute).toISOString()
        return this.props.updateContentEventDates({
          variables: {
            id: event.id,
            startDate: startDate,
            endDate: endDate
          }
        })
      })
    }
    try {
      await Promise.all([
        getDayPromise(firstDay, secondDay),
        getDayPromise(secondDay, firstDay),
        getEventsWithModifiedDatesPromise(firstDay, secondDay),
        getEventsWithModifiedDatesPromise(secondDay, firstDay)])
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }
    // After moving need to reorder the days array by date
    let updatedCustomizedPlan = _.cloneDeep(this.state.trip)
    updatedCustomizedPlan.tripDetails.itineraryDays.sort(function(a,b) {return (a.dayOfTrip > b.dayOfTrip) ? 1 : ((b.dayOfTrip > a.dayOfTrip) ? -1 : 0);} );
    this.setState({trip: updatedCustomizedPlan})
  }
  getCurrentDay() {
    const days = this.getDays()
    return days[this.state.selectedDayIndex].itineraryday
  }
  getDayByDate(day) {
    const days = this.getDays()
    let selected = days.find((d) => {
      return d.dayOfTrip === day.toISOString()
    })
    return selected
  }
  getDays() {
    let days
    if (this.state.trip)  {
      days = this.state.trip.tripDetails.TripItinerarydays
    }
    if (Array.isArray(days)) {
      return _.sortBy(days, ['index'])
    }
    return []
  }
  renderDayTitle() {
    if (this.state.isDayTitleEditing) return null
    const currentDay = this.getCurrentDay()
    if (!currentDay) return null
    let dayTitle = ''

    // console.log('here is redner',currentDay.isFavorite)

    // this.setState({
    //   isToggleOn: currentDay.isFavorite
    // })

    if (currentDay.dayOfTrip) {
      dayTitle += `${moment(currentDay.dayOfTrip).format('MMM D')}, `
    }
    dayTitle += currentDay.title
    return dayTitle
  }
  renderMarkers() {
    const currentDay = this.getCurrentDay()
    return currentDay.contentEvents
      .filter(event => !!_.get(event, 'contentPOIs[0].place'))
      .map((event, i) => <Marker key={i} position={_.get(event, 'contentPOIs[0].place', {})} />)
  }

  onPOIClick = id => {
    this.setState(
      {
        addEventModal: true,
        POIData: _.find(this.state.libraryContentPOIs, function(obj) {
          return obj.id === id.id
        })
      },
      () => {}
    )
  }
  onNoteClick = id => {
    this.setState(
      {
        showLoader: true
      },
      async () => {
        const currentDay = this.getCurrentDay()
        try {
          await this.props.linkIterneraryDayAndNote({
            variables: {
              itineraryDayId: currentDay.id,
              noteId: id.id
            }
          })
        } catch (err) {
          NotificationManager.error(err.message, 'Error', 5000)
        }
        try {
          setTimeout(async () => {
            await this.props.customizedPlan.refetch()
          }, 0)
        } catch (err) {
          NotificationManager.error(err.message, 'Error', 5000)
        }
        this.setState({
          showLoader: false
        })
      }
    )
  }
  onDragStart = () => {
    this.setState({ isDrag: true })
  }
  onDragEnd = result => {
    if (!result.destination) {
      this.setState({ isDrag: false })
      return
    }
    if (result.source.droppableId === 'NOTES') {
      this.onNoteClick({ id: result.draggableId })
    } else if (result.source.droppableId === 'POI') {
      this.onPOIClick({ id: result.draggableId })
    }
    this.setState({ isDrag: false })
  }
  render() {
    if (this.props.customizedPlan.loading || this.props.loading) {
      return <Loader showLoader={true} />
    }
    if (!this.props.user) {
      this.props.history.push('/')
    }
    let customizedPlan = this.state.trip
    const { t } = this.props
    const {
      activeLibraryTab,
      libraryContentPOIs,
      libraryNotes,
      selectedDayIndex,
      addEventModal,
      addExternalDayModal,
      editEventModal,
      editTrip,
      activePlanView,
      searchKey,
      newDayTitle,
      isDayTitleEditing,
      showLoader,
      eventForEditing,
      addNotesModal,
      editNotesModal,
      viewContentNotesModal
    } = this.state
    const days = this.getDays()
    const dropableStyles = { minHeight: '100px', border: '1px solid blue' }
    return (
      <div className="trip">
        <Sidebar
          days={days}
          selectedDayIndex={this.state.selectedDayIndex}
          onAddDay={() => this.onAddDay()}
          onDaySelect={selectedDayIndex => {
            this.setState({ selectedDayIndex })
          }}
          moveDay={(dragIndex, hoverIndex) => {
            this.moveDay(dragIndex, hoverIndex)
          }}
          getFav={(favStatus) =>{
            this.setState({ isToggleOn: favStatus})
          }}
        />
        <DragDropContext onDragStart={this.onDragStart} onDragEnd={this.onDragEnd}>
          <div className="container-fluid" id="DragContext!">
            <div className="row">
              <div className="trip__plan col-md-8">
                <div className="trip__title title">
                  <input
                    type="text"
                    title="Trip Title"
                    value={_.get(customizedPlan, 'tripDetails.title', '')}
                    className="title__input"
                    readOnly={true}
                  />
                  <i
                    className="title__icon icon-edit"
                    onClick={() => {
                      this.setState({
                        editTrip: true
                      })
                    }}
                  />
                </div>
                
                <div  className="trip__title title title__input trip__subtitle">
                    {this.renderDayTitle()}
                    {isDayTitleEditing && (
                      <InputWithOutsideClick
                        value={newDayTitle}
                        inputRef={input => {
                          this.input = input
                        }}
                        onKeyUp={e => {
                          this.onKeyUp(e)
                        }}
                        onChange={newDayTitle => {
                          this.setState({ newDayTitle })
                        }}
                        onClickOutside={() => {
                          this.onClickOutside()
                        }}
                      />
                    )}
                    <i
                      className="title__icon icon-edit"
                      onClick={() => {
                        this.onDayTitleEditClick()
                      }}
                    />
                  </div>
                
                <div className="trip__day-info day-info">
                  <div className="day-info__title"></div>
                  <div className="flex">
                    <div className="day-info__icons">
                      <div
                        className="day-info__icon"
                        onClick={() => {
                          this.setState({
                            addExternalDayModal: true
                          })
                        }}
                      >
                        <i className="icon-arrow-up" />
                      </div>
                      <div
                        className="day-info__icon"
                        onClick={() => {
                          this.setState({
                            activePlanView: LIST_VIEW
                          })
                        }}
                      >
                        <i className="icon-info" />
                      </div>
                      <div
                        className="day-info__icon"
                        onClick={() => {
                          this.onMapViewSelect()
                        }}
                      >
                        <i className="icon-trip-plan" />
                      </div>
                      <div
                        className="day-info__icon"
                        onClick={() => {
                          this.onDeleteAllEvents()
                        }}
                      >
                        <i className="icon-delete" />
                      </div>
                      <div
                        className="day-info__icon"
                        onClick={() => {
                          this.onStarToggle()
                        }}
                      >
                        
                        <i className={this.state.isToggleOn ? 'icon-star-filled' : 'icon-star'}></i>
                        
                      </div>

                    </div>
                    <div className="trip__add-activity add-activity">
                      <button
                        className="add-activity__button"
                        onClick={() => {
                          this.setState({
                            addEventModal: true
                          })
                        }}
                      >
                        {t('add_event')}
                      </button>
                    </div>
                  </div>
                </div>
                <Droppable droppableId="activities-active">
                  {(provided, snapshot) => (
                    <div ref={provided.innerRef} style={this.state.isDrag ? dropableStyles : { minHeight: '100px' }}>
                      {activePlanView === LIST_VIEW ? (
                        <Activities
                          day={this.getCurrentDay()}
                          tripStart={customizedPlan.startDate}
                          tripEnd={customizedPlan.endDate}
                          onTimeEdited={(event, time) => {
                            this.onTimeEdited(event, time)
                          }}
                          onDateEdited={(event, day, newDate) => {
                            this.onDateEdited(event, day, newDate)
                          }}
                          onNotesClick={eventForEditing => {
                            this.setState({
                              editNotesModal: true,
                              eventForEditing
                            })
                          }}
                          onEditClick={eventForEditing => {
                            this.setState({
                              editEventModal: true,
                              eventForEditing
                            })
                          }}
                          onRemoveEvent={eventId => this.onEventRemoveFromPlan(eventId)}
                          onRemoveNote={noteId => this.onNoteRemoveFromPlan(noteId)}
                        />
                      ) : (
                        <Map
                          containerElement={<div className="google-map__container" />}
                          mapElement={<div className="google-map__element" />}
                          markers={this.renderMarkers()}
                          createRef={map => {
                            this.map = map
                          }}
                        />
                      )}
                    </div>
                  )}
                </Droppable>
                <div className="plan-part__add-activity add-activity">
                  <button
                    className="add-activity__button"
                    onClick={() => {
                      this.setState({
                        addEventModal: true
                      })
                    }}
                  >
                    {t('add_event')}
                  </button>
                </div>
              </div>
              <div className="col-md-4 library">
                <h2 className="library__label">{t('library')}</h2>
                

                
                <div className="library__tabs">
                  <div
                    className={classNames({
                      library__tab: true,
                      'library__tab--active': activeLibraryTab === POI
                    })}
                    onClick={() => {
                      this.onLibraryTabChange(POI)
                    }}
                  >
                    {t('poi')}
                  </div>
                  <div
                    className={classNames({
                      library__tab: true,
                      'library__tab--active': activeLibraryTab === NOTES
                    })}
                    onClick={() => {
                      this.onLibraryTabChange(NOTES)
                    }}
                  >
                    {t('notes')}
                  </div>
                </div>
                <div className="library__search search">
                  <input
                    type="text"
                    title="Search"
                    onChange={e => {
                      this.setState({
                        searchKey: e.target.value.toLowerCase()
                      })
                    }}
                    value={searchKey}
                    placeholder={t('search')}
                    className="search__input"
                  />
                  <i className="search__icon icon-search" />
                </div>
                {activeLibraryTab === POI ? (
                  <div
                    className="sidebar__add-day add-day"
                    onClick={() => {
                      this.setState({ POIFormModal: true })
                    }}
                  >
                    <i className="add-day__icon icon-plus" />
                    <span className="add-day__label">{this.props.t('add_poi')}</span>
                  </div>
                ) : (
                  <div className="sidebar__add-day add-day" onClick={() => this.setState({ addNotesModal: true })}>
                    <i className="add-poi__icon icon-plus" />
                    <span className="add-day__label">{t('add_notes')}</span>
                  </div>
                )}
                <div className="library__tip">{t('library_tip')}</div>
                {activeLibraryTab === POI ? (
                  <Droppable droppableId="POI">
                    {/* {(provided, snapshot) => (
                      <div ref={provided.innerRef} style={{ minHeight: '300px', paddingBottom: 30 }}>
                        <div className="library__search-results">
                          {activeLibraryTab === POI &&
                          libraryContentPOIs.filter(({ title, content }) => title.toLowerCase().includes(searchKey.toLowerCase()) || 
                          content.toLowerCase().includes(searchKey.toLowerCase())).map((el, i) => {
                            //libraryContentPOIs.map((el, i) => {
                              console.log(el);
                              console.log(i);
                              let key = this.state.searchKey.toLowerCase()
                              console.log("searchtitle:" +el.title)
                             // if (el.title.toLowerCase().includes(key) || el.description.toLowerCase().includes(key)) {
                               console.log(this.props.contentPOI);
                                return (
                      
                                  <Activity
                                    key={el.id}
                                    data={el}
                                    type="library"
                                    onClick={() => {
                                      this.onPOIClick({ id: el.id })
                                    }}
                                    refetch={this.props.contentPOI.refetch}
                                    onEditClick={eventForEditing => {
                                      this.setState(
                                        {
                                          EditPOIFormModal: true,
                                          eventForEditing
                                        },
                                        () => {}
                                      )
                                    }}
                                  />
                                )
                            //  } else {
                             ///   return null
                            //  }
                            })}
                        </div>
                      </div>
                    )} */}
                    {(provided, snapshot) => (
                      <div ref={provided.innerRef} style={{ minHeight: '300px' }}>
                        <div className="library__search-results">
                          {activeLibraryTab === POI &&
                            libraryContentPOIs.filter(({ title, description }) => 
                             title.toLowerCase().includes(searchKey.toLowerCase()) || 
                            description &&  description.toLowerCase().includes(searchKey.toLowerCase())).map((el, i) => {
                              return (
                                <Activity
                                  key={el.id}
                                  data={el}
                                  onClick={el => this.onPOIClick(el)}
                                  type="library"
                                  refetch={this.props.contentPOI.refetch}
                                  onEditClick={eventForEditing => {
                                    this.setState(
                                      {
                                        EditPOIFormModal: true,
                                        eventForEditing
                                      },
                                      () => {}
                                    )
                                  }}
                                />
                              )
                            })}
                        </div>
                      </div>
                    )}
                  </Droppable>
                ) : (
                  <Droppable droppableId="NOTES">
                    {(provided, snapshot) => (
                      <div ref={provided.innerRef} style={{ minHeight: '300px' }}>
                        <div className="library__search-results">
                          {activeLibraryTab === NOTES &&
                            libraryNotes.filter(({ title, content }) => title.toLowerCase().includes(searchKey.toLowerCase()) || 
                            content.toLowerCase().includes(searchKey.toLowerCase())).map((el, i) => {
                              return (
                                <Activity
                                  key={el.id}
                                  data={el}
                                  onClick={el => this.onNoteClick(el)}
                                  type="library"
                                  refetch={this.props.contentNote.refetch}
                                  onEditClick={eventForEditing => {
                                    this.setState(
                                      {
                                        editNotesModal: true,
                                        eventForEditing
                                      },
                                      () => {}
                                    )
                                  }}
                                />
                              )
                            })}
                        </div>
                      </div>
                    )}
                  </Droppable>
                )}
              </div>
            </div>
          </div>
        </DragDropContext>
        <AddExternalDayModal
          user={this.props.user}
          isOpen={addExternalDayModal}
          currentDay={customizedPlan.tripDetails.TripItinerarydays[selectedDayIndex].itineraryday}
          onClose={(isSaved, event, dayIndex) => {
            this.closeModal(() => {
              return this.onExternalDayCloseModal(isSaved, event, dayIndex)
            })
          }}

          updateFav={(res) =>{
            console.log('favorite response in main',res)
            this.setState({ isToggleOn: res})
          }}
        />
        <AddEventModal
          user={this.props.user}
          isOpen={addEventModal}
          dates={days}
          currentDay={selectedDayIndex}
          POI={_.cloneDeep(this.state.POIData) || null}
          onClose={(isSaved, event, dayIndex) => {
            this.closeModal(() => {
              return this.onEventCloseModal(isSaved, event, dayIndex)
            })
          }}
        />
        <AddPOIFormModal
          isOpen={this.state.POIFormModal}
          dates={days}
          currentDay={selectedDayIndex}
          t={this.props.t}
          user={this.props.user}
          onClose={(isSaved, event, dayIndex) => {
            this.closeModal(() => {
              return this.onEventCloseModal(isSaved, event, dayIndex)
            })
          }}
        />
        <EditPOIFormModal
          isOpen={this.state.EditPOIFormModal}
          dates={days}
          currentDay={selectedDayIndex}
          t={this.props.t}
          user={this.props.user}
          event={eventForEditing}
          onClose={(isSaved, event, dayIndex) => {
            this.closeModal(() => {
              return this.onEventCloseModal(isSaved, event, dayIndex)
            })
          }}
        />
        <EditEventModal
          user={this.props.user}
          isOpen={editEventModal}
          dates={days}
          event={eventForEditing}
          POI={_.cloneDeep(this.state.POIData) || null}
          currentDay={selectedDayIndex}
          onClose={() => {
            this.closeModal(() => this.onEventCloseModal())
          }}
        />
        <EditTripModal
          isTrip={true}
          isOpen={editTrip}
          dates={days}
          user={this.props.user}
          trip={this.state.trip}
          onClose={() =>
            this.closeModal(() => {
              this.onCustomizedPlanCloseModal()
            })
          }
        />
        <AddNotesModal
          isOpen={addNotesModal}
          user={this.props.user}
          onClose={(isSaved, event, dayIndex) => {
            this.closeModal(() => {
              return this.onEventCloseModal(isSaved, event, dayIndex)
            })
          }}
        />
        <EditNoteModal
          isOpen={editNotesModal}
          initialData={eventForEditing}
          user={this.props.user}
          onClose={(isSaved, event, dayIndex) => {
            this.closeModal(() => {
              return this.onEventCloseModal(isSaved, event, dayIndex)
            })
          }}
        />
        <ViewContentNotesModal
          isOpen={viewContentNotesModal}
          data={eventForEditing}
          onClose={(isSaved, event, dayIndex) => {
            this.closeModal(() => {
              return this.onEventCloseModal(isSaved, event, dayIndex)
            })
          }}
        />
        <Loader showLoader={showLoader} />
      </div>
    )
  }
}
export default compose(
  translate('trip_planner'),
  graphql(queries.CREATE_ALL_ITINERARY_DAYS, {
    name: 'createAllItineraryDays'
  }),
  graphql(queries.CREATE_ITINERARY_DAY, {
    name: 'createItineraryDay'
  }),
  graphql(queries.GET_CONTENT_POI, {
    name: 'contentPOI',
    options: props => ({
      variables: {
        tripGuruId: _.get(props, 'user.id', '')
      },
      fetchPolicy: 'network-only'
    })
  }),
  graphql(GET_CONTENT_NOTE, {
    name: 'contentNote',
    options: props => ({
      variables: {
        userId: _.get(props, 'user.id', '')
      },
      fetchPolicy: 'network-only'
    })
  }),
  graphql(queries.GET_CUSTOMIZED_PLAN, {
    name: 'customizedPlan',
    options: props => ({
      variables: {
        id: props.match.params.tripId
      },
      fetchPolicy: 'network-only'
    })
  }),
  graphql(queries.UPDATE_CUSTOMIZED_PLAN_END_DATE, {
    name: 'updateCustomizedPlanEndDate'
  }),
  graphql(queries.UPDATE_EVENT_TITLE, {
    name: 'updateEventTitle'
  }),
  graphql(queries.UPDATE_CONTENT_EVENT_START_DATE, {
    name: 'updateContentEventStartDate'
  }),
  graphql(queries.UPDATE_CONTENT_EVENT_DATES, {
    name: 'updateContentEventDates'
  }),
  graphql(queries.UPDATE_ITINERARY_DAY_TITLE, {
    name: 'updateItineraryDayTitle'
  }),
  graphql(queries.UPDATE_ITINERARY_DAY_FAVORITE, {
     name: 'updateItineraryDayFavorite'
  }),
  graphql(queries.UPDATE_ITINERARY_DAY_ORDER, {
    name: 'updateItineraryDayOrder'
  }),
  graphql(queries.LINK_ITINERARY_DAY_AND_TRIP_DETAILS, {
    name: 'linkItineraryDayAndTripDetails'
  }),
  graphql(queries.LINK_ITINERARY_DAY_AND_CONTENT_EVENT, {
    name: 'linkItineraryDayAndContentEvent'
  }),
  graphql(queries.UN_LINK_ITINERARY_DAY_AND_CONTENT_EVENT, {
    name: 'unlinkItineraryDayAndContentEvent'
  }),
  graphql(queries.LINK_ITINERARY_DAY_AND_NOTE, {
    name: 'linkIterneraryDayAndNote'
  }),
  graphql(queries.UN_LINK_ITINERARY_DAY_AND_TRIP_DETAILS, {
    name: 'unLinkItineraryDayAndTripDetails'
  }),
  graphql(queries.UN_LINK_ITINERARY_DAY_AND_NOTE, {
    name: 'unLinkItineraryDayAndNote'
  }),
  withRouter
)(TripPlanner)



// WEBPACK FOOTER //
// src/components/TripPlanner/index.js